import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
} from "@material-ui/core";
import api from "../../../services/api";
import { toast } from "react-toastify";

const CreateUserModal = ({ open, handleClose, onRefresh }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    password: "",
    gender: "male",
    dob: "",
    vehicle_name: "",
    vehicle_model: "",
    vehicle_color: "",
    vehicle_type: "car",
    capacity: 4,
    registration_no: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        mobile_number: formData.mobile_number,
        password: formData.password,
        gender: formData.gender,
        dob: formData.dob,
        vehicle: formData.vehicle_name ? {
          vehicle_name: formData.vehicle_name,
          vehicle_model: formData.vehicle_model,
          vehicle_color: formData.vehicle_color,
          vehicle_type: formData.vehicle_type,
          capacity: formData.capacity,
          registration_no: formData.registration_no,
        } : null
      };

      const res = await api.post("admin/user/create", payload);
      if (res.status === 201) {
        toast.success("User created successfully");
        onRefresh();
        handleClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create user");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New User</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="First Name"
                name="first_name"
                fullWidth
                required
                variant="outlined"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Last Name"
                name="last_name"
                fullWidth
                required
                variant="outlined"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                required
                variant="outlined"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Mobile Number"
                name="mobile_number"
                fullWidth
                required
                variant="outlined"
                onChange={handleChange}
                placeholder="03xxxxxxxxx"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Password"
                name="password"
                type="password"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                placeholder="Leave blank for default (123456)"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                label="Gender"
                name="gender"
                fullWidth
                variant="outlined"
                value={formData.gender}
                onChange={handleChange}
              >
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Date of Birth"
                name="dob"
                type="date"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <h3 style={{ margin: '16px 0 8px 0', color: '#444' }}>Vehicle Information (Optional)</h3>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Vehicle Name"
                name="vehicle_name"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                placeholder="e.g. Honda Civic"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Vehicle Model"
                name="vehicle_model"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                placeholder="e.g. 2021"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Vehicle Color"
                name="vehicle_color"
                fullWidth
                variant="outlined"
                onChange={handleChange}
              />
            </Grid>
             <Grid item xs={6}>
              <TextField
                select
                label="Vehicle Type"
                name="vehicle_type"
                fullWidth
                variant="outlined"
                value={formData.vehicle_type}
                onChange={handleChange}
              >
                <MenuItem value="car">Car</MenuItem>
                <MenuItem value="van">Van</MenuItem>
                <MenuItem value="suv">SUV</MenuItem>
                <MenuItem value="mpv">MPV</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Capacity (Seats)"
                name="capacity"
                type="number"
                fullWidth
                variant="outlined"
                value={formData.capacity}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Registration No"
                name="registration_no"
                fullWidth
                variant="outlined"
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? "Creating..." : "Create User"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateUserModal;
